import { render, staticRenderFns } from "./ContractorsIcon.vue?vue&type=template&id=5d600c42"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d600c42')) {
      api.createRecord('5d600c42', component.options)
    } else {
      api.reload('5d600c42', component.options)
    }
    module.hot.accept("./ContractorsIcon.vue?vue&type=template&id=5d600c42", function () {
      api.rerender('5d600c42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/ContractorsIcon.vue"
export default component.exports